import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'rwa-account-activate-success',
  templateUrl: './account-activate-success.component.html',
  styleUrl: './account-activate-success.component.scss',
})
export class AccountActivateSuccessComponent {
  @Input() dialogVisible: boolean;

  @Input({ required: true }) msg: string;

  @Output() closeDialog = new EventEmitter<any>();

  close(action): void {
    this.closeDialog.emit(action);
  }
}
